import { gql } from 'apollo-boost';

export const REMOVE_DEVICE = gql`
  mutation removeDevice($deviceId: ID!, $deviceType: String!) {
    removeDevice(deviceId: $deviceId, deviceType: $deviceType)
  }
`;
